import { map, omit } from 'lodash';
import createAction from './createAction';
import UISettings from '../../utils/UISettings';
// Actions
export const COMPARE_POPUP_REQUEST = 'comparePage/COMPARE_POPUP_REQUEST';
export const COMPARE_PRODUCTS_RESPONSE = 'comparePage/COMPARE_PRODUCTS_RESPONSE';
export const COMPARE_PRODUCTS_FAILURE = 'comparePage/COMPARE_PRODUCTS_FAILURE';
export const COMPARE_POPUP_VISIBLE = 'comparePage/COMPARE_POPUP_VISIBLE';
export const COMPARE_POPUP_REMOVE_ITEM = 'comparePage/COMPARE_POPUP_REMOVE_ITEM';

const initialState = { loading: false, visibility: false, compareProductList: {} };
const processApiResponse = (productApiData, technicalDataForProductsToCompare) => {
  map(productApiData, (product) => {
    const productTitle = `${product.brand.label} ${product.label}`;
    const infoData = {
      groupLabel: 'INFO',
      specifications: [
        {
          label: 'header',
          value: [
            // eslint-disable-next-line no-useless-escape
            product.images[0].url.replace(/\/[a-z]_(.*?).jpg/, '\/s_$1.jpg'),
            productTitle,
            product.id
          ]
        },
        {
          label: 'Price',
          value: {
            currentPrice: product.price.amount,
            savingsPrice: product.wasPrice ? product.wasPrice.discountAmount : undefined,
            wasPrice: product.wasPrice ? product.wasPrice.amount : undefined,
            wasPriceFrom: product.wasPrice ? product.wasPrice.dateFrom : undefined,
            wasPriceTo: product.wasPrice ? product.wasPrice.dateTo : undefined
          }
        },
        { label: 'AddToBasket', value: product.id },
        // TODO { label: 'Availability', value: 'Free delivary available' },
        { label: 'CustomerRating', value: product.customerReview }
      ]
    };
    technicalDataForProductsToCompare[product.id].unshift(infoData);
  });
  window.appState.dispatch({
    type: COMPARE_PRODUCTS_RESPONSE,
    payload: technicalDataForProductsToCompare
  });
};

const getProductDetailsToCompare = async (productIds) => {
  const storeApiUrl = UISettings.get('component.hooklogic.api') ||
    UISettings.get('component.psa.api');
  const productApiResponse = await fetch(`${storeApiUrl}/products/${productIds}`,
    { credentials: 'include' });
  const productApiDataJson = await productApiResponse.json();
  const productApiData = productApiDataJson.payload;

  const technicalDataForProductsToCompare = {};
  const promiseForTechnicalApiRequest = map(productApiData, async (product) => {
    const productId = product.id;
    const technicalDataResponse =
            await fetch(`${storeApiUrl}/products/${productId}/technical-specifications`);
    const technicalSpecDataJson = await technicalDataResponse.json();
    technicalDataForProductsToCompare[productId] = technicalSpecDataJson.payload;
    return technicalSpecDataJson;
  });

  Promise.all(promiseForTechnicalApiRequest).then(() => {
    processApiResponse(productApiData, technicalDataForProductsToCompare);
  });
};

export const comparePopupRequestAction = (productIds) => {
  window.appState.dispatch({ type: COMPARE_POPUP_REQUEST });
  getProductDetailsToCompare(productIds);
};

export function toggleComparePopup(visibility) {
  return createAction(COMPARE_POPUP_VISIBLE)({ visibility });
}

export function removeItemComparePopup(productId) {
  return createAction(COMPARE_POPUP_REMOVE_ITEM)({ productId });
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case COMPARE_POPUP_VISIBLE: {
      return { ...state, visibility: action.payload.visibility };
    }

    case COMPARE_POPUP_REMOVE_ITEM: {
      return {
        ...state,
        compareProductList: omit(state.compareProductList, [action.payload.productId])
      };
    }

    case COMPARE_POPUP_REQUEST: {
      return { ...state, loading: true };
    }

    case COMPARE_PRODUCTS_RESPONSE: {
      return { ...state, loading: false, compareProductList: action.payload };
    }
    case COMPARE_PRODUCTS_FAILURE: {
      return {
        ...state, loading: false, compareProductList: {}, error: 'some error occured'
      };
    }
    
    default: {
      return state;
    }
  }
};
